import { render, staticRenderFns } from "./CommissionSetting.vue?vue&type=template&id=39103b92"
import script from "./CommissionSetting.vue?vue&type=script&lang=js"
export * from "./CommissionSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports